// extracted by mini-css-extract-plugin
module.exports = {"lead":"_1riyVTQS"};